<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t('ventasDeCategoriasPorClientes')}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-3">
                            <div class="form-group">
                                <label>{{$t("companya")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idCompany"
                                           filterable
                                           @change="getBusiness()"
                                           :placeholder="$t('seleccionaCompania')">
                                    <el-option v-for="c in listCompany"
                                               class="select-primary"
                                               :value="c.id"
                                               :label="c.name"
                                               :key="c.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change="getSalesCategoriaClientes()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>&nbsp;</label>
                                <button class="btn btn-primary" @click="getSalesCategoriaClientes()"
                                        style="width: 100%">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-8" v-if="respuesta">
                <template v-if="list.length>0">
                        <h4 style="margin-top: -20px" v-if="listNames.length>0">{{$t('desgloseDeVentasDeLaCategoria')}} <span class="text-primary">{{listNames[numFather-1]}}</span></h4>

                        <button v-if="listNames.length>0" class="btn btn-primary"
                                @click="accionarChildrens(index,obj,false)"><i
                                class="fas fa-arrow-circle-left"></i>
                            {{$t("volverA")}} <span v-if="listNames.length<2">{{$t("general")}}</span>
                            {{listNames[numFather-2]}}
                        </button>


                    <div class="table-responsive">
                        <table class="table table-bordered table-striped text-nowrap">
                            <thead class="thead-dark">
                            <tr>
                                <th v-if="ordenarCliente===0" @click="sortedArrayNameASC()"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("categoria")}}
                                </th>
                                <th v-else @click="sortedArrayNameDESC('name')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("categoria")}}
                                </th>

                                <th v-if="ordenarImporte===0" @click="sortedArrayImporteASC('amount')"><i
                                        style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}}
                                </th>
                                <th v-else @click="sortedArrayImporteDESC('amount')"><i
                                        style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}}
                                </th>
                                <th>{{$t('acciones')}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="obj in list">
                                <td width="40%">{{obj.name}}</td>
                                <td width="40%" align="right">{{obj.price | currency}}</td>
                                <td width="10%" align="center">
                                    <div class="btn btn-primary btn-link">
                                        <i v-if="obj.childrens.length>0"
                                           v-tooltip.top-center="$t('verImporteEnCategoriasHijas')"
                                           style="cursor: pointer"
                                           @click="accionarChildrens(index,obj,true)"
                                           class="fas fa-arrow-circle-right"></i>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr class="table-success">
                                <td><strong>{{$t("total")}}</strong></td>
                                <td class="text-right"><strong>{{getTotalPrecio | currency}}</strong></td>
                                <td>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHay")}} <strong>{{$t("ventasPorClientes")}}</strong> {{$t("rangoDeFechas")}}
                    </div>
                </template>
            </div>

            <div class="col-md-4 " v-show="list.length > 0">
                <div class="card">
                    <canvas id="chart"></canvas>


                </div>
            </div>

        </div>
    </div>

</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", "Ventas de categorias por clientes");
            this.getCompanies();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }

        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                listBusinesses: [],
                idBusiness: 0,
                list: [],
                mode: 0,
                contador: 0,
                chartIn: 0,
                listCompany: [],
                idCompany: 0,

                ordenarInvitations: 0,
                ordenarConsumiciones: 0,
                ordenarImporte: 0,
                ordenarCliente: 0,
                ordenarMedio: 0,

                respuesta: true,


                listFather: [],
                numFather: 0,
                listNames: [],

            }
        },
        computed: {
            urlExportPDF() {
                // return "../api/public/index.php/clients/exportSalesByClients/PDF?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt

                return this.$store.getters.apiUrl + "/clients/exportSalesByClients/PDF?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },
            urlExportExcel() {
                // return "../api/public/index.php/clients/exportSalesByClients/Excel?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt

                return this.$store.getters.apiUrl + "/clients/exportSalesByClients/Excel?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },

            getTotalPrecio() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.price;
                });
                return total;
            },
        },
        methods: {


            sortedArrayNameASC: function () {
                this.ordenarCliente = 1;

                function compare(a, b) {
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameDESC: function () {
                this.ordenarCliente = 0;

                function compare(a, b) {

                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteASC: function () {
                this.ordenarImporte = 1;

                function compare(a, b) {
                    if (a.amount < b.amount)
                        return -1;
                    if (a.amount > b.amount)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteDESC: function () {
                this.ordenarImporte = 0;

                function compare(a, b) {

                    if (a.amount > b.amount)
                        return -1;
                    if (a.amount < b.amount)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },


            getCompanies() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
                    .then(function (response) {

                        if (!vm.idCompany) {
                            vm.idCompany = response.data.result[0].id;
                        }
                        vm.listCompany = response.data.result;

                        vm.getBusiness()

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getBusiness() {
                var config = {
                    params: {
                        idCompany: this.idCompany,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByCompany", config)
                    .then(function (response) {

                        vm.listBusinesses = [];

                        if (response.data.result.length > 0) {


                            let xDate = {

                                checked: false,
                                establishmentName: vm.$t('todos'),
                                id: 0
                            };
                            vm.listBusinesses.push(xDate);
                        }


                        for (let i = 0; i < response.data.result.length; i++) {

                            let xDate = {

                                checked: response.data.result[i].checked,
                                establishmentName: response.data.result[i].establishmentName,
                                id: response.data.result[i].id
                            };

                            vm.listBusinesses.push(xDate);

                        }

                        vm.getSalesCategoriaClientes();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getSalesCategoriaClientes() {

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                } else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.loading = true;

                        this.numFather = 0;
                        this.listFather = [];
                        this.listNames = [];

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idCompany: this.idCompany,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.axios.get(this.$store.getters.apiUrl + "clients/getVentasCategoriesClientsByCompany", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    vm.list = response.data.result;
                                    vm.respuesta = true;

                                    vm.initChart();

                                } else {
                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                    vm.respuesta = false;

                                }
                                vm.loading = false;

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },

            accionarChildrens(index, obj, hijo) {


                if (hijo) {
                    this.listFather.push(this.list);
                    this.numFather++;

                    this.list = obj.childrens;


                    if (obj.price - this.getTotalPrecio !== 0) {

                        let xDate = {
                            name: obj.name,
                            price: obj.price - this.getTotalPrecio,
                            childrens: [],
                            ref: obj.ref,
                            parentCode: 0

                        };
                        this.list.push(xDate);

                    }


                    this.listNames.push(obj.name);

                } else {

                    this.numFather--;
                    this.listNames.splice(this.numFather, 1);
                    this.list = this.listFather[this.numFather];

                }

                this.initChart();

            },
            initChart() {


                let labels = this.list.map(function (x) {
                    return x.name;
                });


                let data = this.list.map(function (x) {
                    return x.price;
                });


                var randomColor = require('randomcolor');

                var colors = randomColor({luminosity: 'dark', count: labels.length, format: 'rgb'});

                let backgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
                });

                let borderColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
                });

                let hoverBackgroundColors = colors.map(function (x) {
                    let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                    return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
                });

                if (this.contador == 0) {

                    if (this.list.length > 0) {
                        this.objectChart = new Chart("chart", {

                            type: 'pie',
                            data: {
                                labels: labels,
                                datasets: [{
                                    data: data,
                                    backgroundColor: backgroundColors,
                                    borderColor: borderColors,
                                    hoverBackgroundColor: hoverBackgroundColors,
                                    borderWidth: 1
                                }]
                            },
                            options: {
                                legend: {
                                    display: true,
                                    position: 'bottom',

                                }
                            }
                        });


                        this.contador++;
                    }
                }
                else {

                    this.objectChart.destroy();

                    this.objectChart = new Chart("chart", {

                        type: 'pie',
                        data: {
                            labels: labels,
                            datasets: [{
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1
                            }]
                        },
                        options: {
                            legend: {
                                display: true,
                                position: 'bottom'
                            }
                        }
                    });

                }
            }

        }
    }
</script>

<style scoped>


    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Clientes/VentasCategoriaClientes.vue